import JacobyMeyers from 'features/shared/assets/app-logo/jacoby-meyers.svg';

export default function AppLogo() {
  return <img src={JacobyMeyers} alt="logo" />;
}
